/** The admin shell's own words — header, rail, page search, footer. */
export const shell = {
  /** Legacy `title` on the burger, which is English in _AdminsBaseLayout too. */
  toggleSidebar: 'Show sidebar menu',
  menu: 'القائمة الرئيسية', // Master.MainMenu
  userPanel: 'لوحة المستخدم', // Master.UserPanel
  userGuide: 'دليل المستخدم', // Master.UserManual
  consoleLogs: 'سجلات الكونسول',
  profile: 'الملف الشخصي', // Master.Profile
  /** The trail shown for the two destinations that live in the account menu. */
  account: 'الحساب',
  logout: 'خروج', // Master.Logout
  close: 'إغلاق', // Resources.Close
  version: 'الإصدارة', // Master.Version
  language: 'اللغة', // Resources.Language

  /* The command search. It searches panels INSIDE pages as well as pages, so
     the placeholder no longer promises only the latter. */
  search: 'ابحث عن صفحة أو قسم',
  searchEmpty: 'لا توجد نتائج مطابقة',
  searchClear: 'مسح البحث',
  searchRecent: 'آخر ما فتحت',
  searchPages: 'الصفحات',
  searchSections: 'الأقسام',
  searchActions: 'إجراءات',
  searchMove: 'للتنقل',
  searchOpen: 'للفتح',
  searchClose: 'للإغلاق',

  placeholderTitle: 'هذه الصفحة قيد الإعداد',
  placeholderDesc: 'سيتم بناء هذه الشاشة في مرحلة لاحقة من إعادة التصميم.',

  /* The bootstrap call could not be answered. Deliberately not "your session
     ended" — an unreachable server is not a sign-out, and saying so would send
     the user to log in again over an outage they cannot fix. */
  sessionErrorTitle: 'تعذّر الاتصال بالخادم',
  sessionErrorDesc: 'لم نتمكن من قراءة بيانات جلستك. تحقق من الاتصال ثم أعد المحاولة.',
  retry: 'إعادة المحاولة',
}
